import {APP_INITIALIZER, NgModule} from '@angular/core';
import {menu} from './menu';
import {routes} from './routes';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import {RouterModule} from '@angular/router';
import {SharedModule} from '../shared/shared.module';
import {PagesModule} from './pages/pages.module';

import {LoaderInterceptor} from '../shared/interceptors/loader.interceptor';
import {JwtInterceptor} from '../shared/interceptors/jwt.interceptor';
import {ErrorInterceptor} from '../shared/interceptors/error.interceptor';
import {appInitializer} from '../shared/functions/app.initializer';

import {TranslatorService} from '../core/translator/translator.service';
import {MenuService} from '../core/menu/menu.service';
import {AuthenticationService} from '../shared/services/authentication.service';


@NgModule({
  imports: [
    SharedModule,
    PagesModule,
    RouterModule.forRoot(routes)
  ],
  providers: [
    {provide: APP_INITIALIZER, useFactory: appInitializer, multi: true, deps: [AuthenticationService]},
    {provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true}
  ],
  declarations: [],
  exports: [
    RouterModule
  ]
})

export class RoutesModule {
  constructor(public menuService: MenuService, tr: TranslatorService) {
    menuService.addMenu(menu);
  }
}
